import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Api from '../../../Auth/Api';
import AddTopicoModal from '../Modals/AddTopicoModal';

const TopicosManager = ({ token, onTopicoCreated }) => {
    const [showModalAddTopico, setShowModalAddTopico] = useState(false);
    const [reloadDataTopicos, setReloadDataTopicos] = useState(false);
    const [dataTopicos, setDataTopicos] = useState([]);
    const [idTopico, setIdTopico] = useState();
    
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    // Carregar tópicos
    useEffect(() => {
        async function fetchTopicos() {
            try {
                const response = await Api.get(`api/listar-topicos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataTopicos(response.data);
            } catch (error) {
                console.error("Erro ao carregar tópicos:", error.response?.data?.message || error);
            }
        }
        fetchTopicos();
    }, [token, idTopico, reloadDataTopicos]);

    const onSubmitAddTopico = async (data) => {
        try {
            const response = await Api.post("api/novo-topico", data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            reset();
            setReloadDataTopicos(!reloadDataTopicos);
            
            // Chamar callback se fornecido
            if (onTopicoCreated) {
                onTopicoCreated();
            }
            
            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            console.error("Erro ao criar novo tópico:", error);
            
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar tópico"
            };
        }
    };

    const openAddTopicoModal = () => {
        setShowModalAddTopico(true);
    };

    return {
        dataTopicos,
        idTopico,
        setIdTopico,
        openAddTopicoModal,
        showModalAddTopico,
        setShowModalAddTopico,
        onSubmitAddTopico,
        renderModal: (setShowModalAddCurso) => (
            <AddTopicoModal
                showModalAddTopico={showModalAddTopico}
                setShowModalAddTopico={setShowModalAddTopico}
                setReloadDataTopicos={setReloadDataTopicos}
                reloadDataTopicos={reloadDataTopicos}
                setShowModalAddCurso={setShowModalAddCurso}
                token={token}
                register={register}
                handleSubmit={handleSubmit}
                errors={errors}
                onSubmitAddTopico={onSubmitAddTopico}
            />
        )
    };
};

export default TopicosManager; 